import { getEnvironment } from 'app/functions/environment';

export const isDevelopment = () => getEnvironment() === 'development';
